import { render, staticRenderFns } from "./ExpensesSummaryCards.vue?vue&type=template&id=68dfe979&scoped=true"
import script from "./ExpensesSummaryCards.vue?vue&type=script&lang=js"
export * from "./ExpensesSummaryCards.vue?vue&type=script&lang=js"
import style0 from "./ExpensesSummaryCards.vue?vue&type=style&index=0&id=68dfe979&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dfe979",
  null
  
)

export default component.exports